import { createRoot } from "react-dom/client";

// third party
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

// project imports
import * as serviceWorker from "serviceWorker";
import App from "App";
import { store } from "store";

// style + assets
import "assets/scss/style.scss";
import config from "./config";
import axios from "axios";
import { showError } from "store/errorReducer";
import ErrorToast2 from "utils/ErrorToast2";

// ==============================|| REACT DOM RENDER  ||============================== //

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript

// axios.interceptors.response.use(
//   (response) => response,

//   (error) => {
//     const status = error.response?.status;
//     const code = error.code;

//     console.error("Axios Error:", {
//       message: error.message,
//       status,
//       code,
//       url: error.config?.url,
//       method: error.config?.method,
//       data: error.response?.data,
//     });

//     const shouldDispatch = status === 401 || code === "ERR_NETWORK";

//     if (shouldDispatch) {
//       const payload = {
//         message: error.message,
//         status,
//         code,
//       };

//       store.dispatch(showError(payload));
//     }

//     return Promise.reject(error);
//   },
// );
root.render(
  <Provider store={store}>
    <BrowserRouter basename={config.basename}>
        <App />
        <ErrorToast2 />
    </BrowserRouter>
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
